<!--
 * @Author: gongzhichao
 * @Date: 2023-05-09 16:57:00
 * @LastEditors: gongzhichao 18311120024@163.com
 * @Description: 下载工具组件
-->
<template>
  <div class="download">
    <div class="map">
      <div class="content">
        <div class="qr-code code-margin1">
          <img src="../../../../assets/image/pc/download-test-1.png" alt="" />
          <div class="saomiao"></div>
        </div>
        <span style="font-size: 15px">扫码下载游戏</span>
        <div class="download-button and">
          <a :href="urls.anxUrl" style="color: #3b2606">安卓下载</a>
          <!-- <a @click="message()">安卓下载</a> -->
        </div>
        <div class="download-button ios">
          <a :href="urls.iosUrl">IOS下载</a>
          <!-- <a @click="message()">IOS下载</a> -->
        </div>
        <div class="qr-code code-margin2">
          <img src="../../../../assets/image/pc/wechat-code.jpg" alt="" />
          <div class="saomiao"></div>
        </div>
        <span style="font-size: 18px">微信公众号</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      urls: {},
    };
  },
  mounted() {
    this.getDownloadUrls();
  },
  methods: {
    ...mapActions({ getDownloadUrl: "base/getDownloadUrl" }),
    async getDownloadUrls() {
      let ulrs = await this.getDownloadUrl(); // 下载地址
      this.urls = ulrs;
    },

    message() {
      alert("敬请期待！");
    },
  },
};
</script>

<style lang="scss" scoped>
.download {
  padding: 0 16px 0 46px;
  margin-top: 70px;
  .map {
    padding: 19px 33px 19px 13px;
    background: url("~@/assets/image/pc/basemap-utils-1.png") no-repeat;
    background-size: 100% 100%;
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 198px;
      height: 547px;
      .qr-code {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 151px;
        height: 151px;
        background-color: #fff;
        border-radius: 30px;
        position: relative;
        box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
          0px 10px 15px -3px rgba(0, 0, 0, 0.1);
        img {
          width: 135px;
          height: 135px;
        }
        .saomiao {
          width: 80%;
          height: 26px;
          background: linear-gradient(
            180deg,
            #000 0%,
            rgba(255, 255, 255, 0) 100%
          );
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: 15px;
          background: url("~@/assets/image/pc/line.png") no-repeat;
          background-size: 100% 100%;
          animation: move 1.5s infinite alternate;
          -webkit-animation: move 1.5s infinite alternate;
        }

        @keyframes move {
          from {
            top: 10px;
          }
          to {
            top: 108px;
            opacity: 0.8;
          }
        }
      }
      .code-margin1 {
        margin-top: 26px;
        margin-bottom: 6px;
      }
      .code-margin2 {
        margin-top: 29px;
        margin-bottom: 10px;
      }
      .download-button {
        width: 137px;
        height: 36px;
        line-height: 36px;
        background-size: 100% 100%;
        margin-top: 15px;
        cursor: pointer;
        a {
          font-size: 16px;
          padding-left: 50px;
          color: #fff;
        }
      }
      .and {
        background: url("~@/assets/image/pc/button-and.png") no-repeat center;
      }
      .ios {
        background: url("~@/assets/image/pc/button-ios.png") no-repeat center;
      }
      span {
        color: #63492b;
      }
    }
  }

  .qr {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      margin: 10px 0;
    }
    .dow-img {
      width: 200px;
      margin-bottom: 20px;
    }
    img:hover {
      animation: styles_pulse-loader__5535u 1.5s ease-out infinite;
    }
    @keyframes styles_pulse-loader__5535u {
      0% {
        -webkit-transform: scale(1);
        transform: scale(1);
      }
      20% {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
      }
      80% {
        -webkit-transform: scale(1);
        transform: scale(1);
      }
    }
    .dow-img:last-child {
      margin-bottom: 0px;
    }
  }
}
</style>
